/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import { TweetyWidget } from '@/widgets/tweety-widget-react-main';
import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { ProgressBar } from '../ProgressBar';
import { Error, Span, Star } from './styles';
import { ItemSpecVenusWidget } from '../../../../widgets/item-spec-venus-widget-react';
import { toCamelCase, toUpperCase } from 'js-convert-case';
import { toUpper } from 'lodash';
import { IHeaderCompProps, RightContainer } from '../RightContainer';
import { StorageModule } from '@vlinder-web/storage-module-react';

interface IFormData {
  fields: any[];
  newFields: any[];
  selectFormFields: any[];
  existingFields: any[];
  existingLayout: any[];
  selectFormLayout: any[];
  confirmField: any[];
  newLayout: any[];
  validatorConfig?: any;
  dynamicLayout?: any[];
  previewLabel?: string;
  progressBarSteps?: string[];
}

export const FormComp = ({
  formData,
  onAcknowledgement,
  onGoBack,
  label,
  field,
  whoami,
  rightBlockContent,
  onNextClick,
}: {
  whoami: String;
  label?: string;
  formData: IFormData;
  field?: any;
  onAcknowledgement?(payload: any): void;
  onGoBack?(): void;
  rightBlockContent?: any;
  onNextClick?(payload: anyy): void;
}) => {
  const {
    fields,
    existingFields,
    confirmField,
    existingLayout,
    newFields,
    newLayout,
    dynamicLayout,
    validatorConfig,
    previewLabel,
    selectFormFields,
    selectFormLayout,
    selectvalidatorConfig,
  } = formData;

  const [formFields, setFormFields] = useState(fields);
  const [activeStep, setActiveStep] = useState(0);
  const [initialData, setinitialData] = useState({});
  const [selectForm, setselectForm] = useState('');
  const [layout, setlayout] = useState([]);

  console.log('initialData2', initialData);
  const _getDocument = (payload: any) => {
    console.log('paylooads', payload);
    const availDocuments = {
      businessRegistration: 'BUSSINESS_REGISTRATION',
      taxClearanceCertificate: 'TAX_CLEARANCE_CERTIFICATE',
      articleOfIncorporation: 'ARTICAL_OF_INCORPORATION',
      certificateOfIncorporation: 'CERTIFICATE_OF_INCORPORATION',
      annualReturn: 'ANNUAL_RETURN',
      immigrationStatus: 'IMMIGRATION_STATUS',
      certificateOfGoodStading: 'CERTIFICATE_OF_GOOD_STANDING',
      bankStatement: 'BANK_STATMENT',
      existingInvoices: 'EXISTING_INVOICES',
      leaseOrRentalAgreement: 'LEASE_AGREEMENT',
      companyReceipt: 'COMPAY_OFFICE_OF_JAMAICA_RECEIPT',
    };
    let _documents: any = {};
    availDocuments &&
      Object.entries(availDocuments).forEach((ele, index) => {
        let _similarDoc: any[] = [];
        payload &&
          Array.isArray(payload) &&
          payload.length > 0 &&
          payload.map((doc: any) => {
            if (doc?.type === ele[1]) {
              _similarDoc.push({
                name: doc?.name,
                src: doc?.src,
                type: doc?.fileType,
              });
            }
          });
        _documents[ele[0]] = _similarDoc;
      });
    console.log('formatAppDraft getDocuments ', _documents);
    console.log('paylooads2', _documents);
    return _documents;
  };

  const formatData = (data: any) => {
    return data?.map((ele) => {
      return { ...ele?.address, ...ele };
    });
  };

  useEffect(() => {
    const storageService = StorageModule.getInstance();
    const _localData = storageService.get('myProfile', 'local');
    const _sessionData = storageService.get('myProfile', 'session');
    const userData = _sessionData ?? _localData;
    console.log('USANDATA', userData, initialData);

    const documents = _getDocument(userData?.org?.documents);
    console.log('123213123', documents);
    if (userData?.email && whoami !== 'prospective_employee') {
      setinitialData({
        ...initialData,
        ...documents,
        email: userData?.org?.email,
        trn: userData?.org?.trn,
        name: userData?.org?.name,
        tradingName: userData?.org?.tradingName,
        primaryContactNo: userData?.org?.primaryContactNo,
        companyEmail: userData?.org?.email,
        incorporationDate: userData?.org?.incorporationDate,
        type: userData?.org?.type,
        registrationNo: userData?.org?.registrationNo,
        isAddressSame: !userData?.org?.operatingAddress?.addressLine1,
        addressLine1: userData?.org?.address?.addressLine1,
        addressLine2: userData?.org?.address?.addressLine2,
        addressLine3: userData?.org?.address?.addressLine3,
        city: userData?.org?.address?.city,
        parish: userData?.org?.address?.parish,
        country: userData?.org?.address?.country,
        state: userData?.org?.address?.state,
        zipcode: userData?.org?.address?.zipcode,
        natureOfBusiness: userData?.org?.natureOfBusiness,
        operatingaddressLine1: userData?.org?.operatingAddress?.addressLine1,
        operatingaddressLine2: userData?.org?.operatingAddress?.addressLine2,
        operatingCity: userData?.org?.operatingAddress?.city,
        operatingParish: userData?.org?.operatingAddress?.parish,
        operatingzipcode: userData?.org?.operatingAddress?.zipcode,
        website: userData?.org?.website,

        branches: formatData(userData?.org?.branches),
        directors: formatData(userData?.org?.directors),
        subsidiaries: formatData(userData?.org?.subsidiaries),
        isAddDirector: userData?.org?.directors
          ? userData?.org?.directors?.length === 0
            ? 'no'
            : 'yes'
          : null,
        isAddBranch: userData?.org?.branches
          ? userData?.org?.branches?.length === 0
            ? 'no'
            : 'yes'
          : null,
        isAddSubsidiary: userData?.org?.subsidiaries
          ? userData?.org?.subsidiaries?.length === 0
            ? 'no'
            : 'yes'
          : null,

        // bankStatement:userData?.org?.documents[0]?.src
      });
    }
  }, []);

  const onActiveStepChange = () => {
    if (activeStep === 0) {
      onGoBack && onGoBack();
    } else {
      setActiveStep(activeStep - 1);
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [activeStep]);
  console.log(initialData);

  useEffect(() => {
    if (selectForm === 'new') {
      setFormFields([...fields, ...newFields]);
      setlayout([...newLayout]);
    } else if (selectForm === 'existing') {
      setlayout([...existingLayout]);
      let __fields =
        fields &&
        fields.map((_field: any) => {
          if (_field?.compProps?.id === 'website') {
            return {
              ..._field,
              compProps: {
                ..._field.compProps,
                required: true,
              },
            };
          } else return _field;
        });
      setFormFields([...__fields, ...existingFields]);
    }
  }, [selectForm]);

  const _renderHeader = (isPreview: boolean) => {
    return (
      <div className="mt-2">
        {/* {isPreview && (
          <h3 className="text-uppercase text-center">{previewLabel}</h3>
        )} */}
        <h4 className="text-center">{isPreview ? previewLabel : label}</h4>
      </div>
    );
  };
  const getProgressSteps = () => {
    return formData.progressBarSteps!.map((step, key: number) => {
      return step;
    });
  };

  const getWidgetData = () => {
    const formData: any[] = [];
    const fileData: any[] = [];
    const specialData: any[] = [];
    const specialNavItems: any[] = [];

    const special = {
      directors: 'Director',
      subsidiaries: 'Subsidiary',
      branches: 'Branch',
    };
    if (initialData && Object.entries(initialData)?.length > 0) {
      Object.entries(initialData)?.forEach((item) => {
        if (special[item[0]] && Array.isArray(item[1])) {
          specialNavItems.push({
            key: item[0],
            title: toCamelCase(item[0]),
            link: `/${item[0]}`,
            type: 'navbar',
          });

          const ele = formFields?.filter(
            (_item: any) => _item?.compProps?.id === item[0]
          )?.[0];
          const reqEle = ele?.compProps?.attributeForm?.fields;
          const totalData: any[] = [];
          item[1]?.forEach((val) => {
            const currData: any[] = [];
            Object.entries(val)?.forEach((_item) => {
              const ans = reqEle?.filter(
                (element) => _item[0] === element?.compProps?.id
              )?.[0];
              if (_item[0] !== 'id' && ans?.compProps?.label && _item[1]) {
                currData.push({
                  title: ans?.compProps?.label,
                  subTitle: _item[1],
                });
              }
            });
            totalData.push(currData);
          });

          specialData.push({
            type: 'accordion',
            key: item[0],
            data: totalData?.map((data, key: number) => {
              return {
                type: 'multi-col-list',
                title: `${special[item[0]]} ${key + 1}`,
                numberOfColumns: '3',
                data: data,
              };
            }),
          });

          console.log('special->', specialData);
        } else if (Array.isArray(item[1])) {
          const ele = formFields?.filter(
            (_item: any) => _item?.compProps?.id === item[0]
          )?.[0];
          if (ele) {
            if (item[1][0]?.type === 'image/png') {
              fileData.push({
                type: 'img',
                src: item[1][0]?.base64 ?? item[1][0]?.src,
                meta: [item[1][0]?.name, item[1][0]?.size],
                title: [ele?.compProps?.label],
              });
            } else if (item[1][0]?.type === 'application/pdf') {
              fileData.push({
                type: 'pdf',
                src: item[1][0]?.base64 ?? item[1][0]?.src,
                meta: [item[1][0]?.name, item[1][0]?.size],
                title: [ele?.compProps?.label],
              });
            } else if (item[1][0]?.type === 'image/jpeg') {
              fileData.push({
                type: 'img',
                src: item[1][0]?.base64 ?? item[1][0]?.src,
                meta: [item[1][0]?.name, item[1][0]?.size],
                title: [ele?.compProps?.label],
              });
            }
          }
        } else {
          const ele = formFields?.filter(
            (_item: any) => _item?.compProps?.id === item[0]
          )?.[0];
          if (ele && !item[0]?.startsWith('is') && item[1]) {
            formData.push({ title: ele?.compProps?.label, subTitle: item[1] });
          }
        }
      });
      const widgetData = {
        profileData: {
          activeKey: 'orgDetails',
          submitBtnText: 'Submit',
          checkBoxText:
            'I certify to the best of my knowledge and belief, that the above information is correct.',
          navItems: [
            {
              key: 'orgDetails',
              title: 'Organization Details',
              link: '/personal',
              type: 'navbar',
            },
            ...specialNavItems,
            {
              key: 'documents',
              title: 'Documents',
              link: '/documents',
              type: 'navbar',
            },
          ],
        },
        itemSpecData: [
          {
            type: 'accordion',
            key: 'orgDetails',
            data: [
              {
                type: 'multi-col-list',
                title: 'Organization Details',
                numberOfColumns: '3',
                data: formData,
              },
            ],
          },
          ...specialData,
          {
            type: 'media-carousel',
            key: 'documents',
            data: fileData,
          },
        ],
        paginationProps: {
          totalCount: 2,
          totalPages: 1,
          forcePage: 0,
          totalItems: 2,
        },
      };
      return widgetData;
    }
    return {};
  };

  console.log('lio->', initialData);

  const _renderSubmitButton = () => {
    return (
      <Row
        className="mt-3"
        style={{ justifyContent: 'space-around', display: 'flex' }}
      >
        {/* <Button
          variant="secondary"
          type="button"
          className="mt-2 animate-up-2"
          style={{
            width: '25%',
            borderRadius: '0px',
            height: '40px',
            fontWeight: 'bold',
          }}
          disabled
        >
          {'Save for later'}
        </Button> */}
        <Col xs={12} md={5} lg={4}>
          <Button
            variant="secondary"
            type="submit"
            className="mt-2 animate-up-2"
            style={{
              borderRadius: '0px',
              height: '40px',
              fontWeight: 'bold',
            }}
          >
            {activeStep <= 1 ? 'Next' : 'Submit'}
          </Button>
        </Col>
      </Row>
    );
  };

  console.log(activeStep);

  const _renderBody = () => {
    console.log(layout, confirmField);
    if (activeStep === 2) {
      let _fields: any = [];

      _fields = formFields.map((_field: any) => {
        if (_field?.compProps?.id === 'confirmDetails') {
          return _field;
        }

        return {
          ..._field,
          compProps: { ..._field.compProps, disabled: true, readOnly: true },
        };
      });

      console.log(`bla`, _fields, layout);

      return (
        <>
          {_renderHeader(true)}
          {/* <div style={{ justifyContent: 'center', display: 'flex' }}>
            <div style={{ width: '60%' }}>
              <TweetyWidget
                labelColor={'#104382'}
                fields={_fields}
                key={2}
                initialData={initialData}
                layout={[...layout, confirmField]}
                dynamicLayout={dynamicLayout}
                validatorConfig={validatorConfig}
                onFormSubmit={(payload: any) => {
                  setActiveStep(activeStep + 1);
                  console.log(payload, 'hi->');
                  onAcknowledgement &&
                    onAcknowledgement({
                      ...payload,
                      isNewOne: selectForm === 'new',
                    });
                }}
                renderSubmitButton={_renderSubmitButton}
                submitButtonLabel={'Submit'}
              />
            </div>
          </div> */}
          {/* @ts-ignore */}
          <ItemSpecVenusWidget
            {...getWidgetData()}
            onListClick={(item: any) => console.log(`item clicked`, item)}
            onPageChange={(event: any) => console.log(`page change`, event)}
            onSubmit={() => {
              setActiveStep(activeStep + 1);
              console.log(initialData, 'hi->');
              onAcknowledgement &&
                onAcknowledgement({
                  ...initialData,
                  isNewOne: selectForm === 'new',
                });
            }}
            onActionClick={(key, listId) =>
              console.log(`on action click`, key, listId)
            }
            // onItemClick={(itemId: string) => window.alert(itemId)}
          />
        </>
      );
    }
    if (activeStep === 0) {
      console.log(selectFormFields, selectFormLayout, 'hib->');
      return (
        <>
          <div style={{ justifyContent: 'center', display: 'flex' }}>
            <div style={{ width: '60%' }}>
              <TweetyWidget
                labelColor={'#104382'}
                key={0}
                fields={selectFormFields}
                validatorConfig={selectvalidatorConfig}
                layout={selectFormLayout}
                initialData={selectForm ? { companyType: selectForm } : {}}
                onFormSubmit={(payload: any) => {
                  console.log('', payload);
                  setselectForm(payload?.['companyType']);
                  setActiveStep(activeStep + 1);
                }}
                renderSubmitButton={_renderSubmitButton}
                submitButtonLabel={'Next'}
              />
            </div>
            <RightContainer
              rightBlockContent={rightBlockContent?.selectCountry}
            />
          </div>
        </>
      );
    }
    console.log(layout, formFields, 'bla');
    if (activeStep === 1 && layout?.length > 0) {
      return (
        <>
          {_renderHeader(false)}
          <div style={{ justifyContent: 'center', display: 'flex' }}>
            <div style={{ width: '60%' }}>
              <TweetyWidget
                labelColor={'#104382'}
                key={`${activeStep}${selectForm}`}
                fields={formFields}
                initialData={initialData}
                layout={layout}
                dynamicLayout={dynamicLayout}
                onFormSubmit={(payload: any) => {
                  setinitialData({ ...initialData, ...payload });
                  console.log(payload, 'hi->');
                  setActiveStep(activeStep + 1);
                  onNextClick &&
                    onNextClick({
                      ...initialData,
                      ...payload,
                      isNewOne: selectForm === 'new',
                    });
                }}
                renderSubmitButton={_renderSubmitButton}
                validatorConfig={validatorConfig}
                submitButtonLabel={'Next'}
              />
            </div>
          </div>
        </>
      );
    }
  };
  return (
    <>
      <ProgressBar
        onActiveStepChange={onActiveStepChange}
        activeStep={activeStep}
        totalSteps={2}
        onCloseClick={onGoBack}
        progressBarSteps={getProgressSteps()}
      />
      {_renderBody()}
    </>
  );
};

FormComp.defaultProps = {
  field: {
    label: 'Select Company Incorporation Status',
    options: [
      {
        label: 'Select..',
        value: '',
      },
      {
        label: 'New',
        value: 'new',
      },
      {
        label: 'Existing',
        value: 'existing',
      },
    ],
  },
};
